import axios from 'axios';

let authExpirationHandler = null;

export const setAuthExpirationHandler = (handler) => {
    authExpirationHandler = handler;
};

const AxiosConfig = axios.create({
    baseURL: import.meta.env.VITE_BASE_URL,
});

AxiosConfig.interceptors.request.use((config) => {
    const token = sessionStorage.getItem('auth');
    if (token) {
        config.headers['AuthCode'] = `Bearer ${token}`;
    }

    if (config.method === 'post' && config.data && typeof config.data === 'object') {
        config.headers['Signature'] = import.meta.env.VITE_SIGNATURE_KEY;
    }

    return config;
}, (error) => Promise.reject(error));

AxiosConfig.interceptors.response.use((response) => {
    if (response?.data?.StatusCode === 206) {
        if (authExpirationHandler) {
            authExpirationHandler();
        } else {
            window.location.href = '/logout';
        }
    }
    return response;
}, (error) => {
    if (error.response?.status === 401) {
        if (authExpirationHandler) {
            authExpirationHandler();
        } else {
            window.location.href = '/logout';
        }
    }
    return Promise.reject(error);
});

export default AxiosConfig;
